import AvatarStartFlow from "@/components/shared/AvatarStartFlow";

// Collapsed to a single tap: creates a draft and drops the user straight into the
// builder in voice mode (FR29 / Story 4.4). Draft handling lives in AvatarStartFlow.
export default function AvatarNew() {
  return (
    <AvatarStartFlow
      testid="avatar-new-page"
      eyebrow="Novo avatar"
      title="Vamos criar seu avatar conversando"
      subtitle="A ValiosIA vai te entrevistar por voz. Prefere digitar ou anexar um documento? É só trocar dentro do builder."
    />
  );
}
